<template>
    <div class="Copyright">
        版权声明：本数据仅可免费用于学术用途和其他非商业用途。未经事先许可，不得重新发行或用于商业用途。使用本产品的用户应明确标明来源及作者。
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .Copyright{

    }
</style>